import { Color, type IconData } from '../types';
export { type IconData };

export enum RotationAngle {
    Zero = 0,
    Ninety = 90,
    OneEighty = 180,
    TwoSeventy = 270,
}
export interface Props {
    icon: IconData;
    classes?: string | null;
    svgClasses?: string | null;
    width?: number | null;
    tagName?: string;
    attrs?: {
        [key: string]: unknown;
    };
    svgStyle?: string | null;
    color?: Color | null;
    alwaysBlack?: boolean;
    alwaysWhite?: boolean;
    rotationAngle?: RotationAngle;
}

export { Color };
